<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-09-02 11:33:14
 * @FilePath: \qctsw-vue\packages\app\src\components\Basic\Pagination.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { NuxtLink } from '#components'

const props = withDefaults(defineProps<{
  tagName?: string
  page?: number
  total?: number
  to?: (page: number) => string | void | any
  itemTag?: string
}>(), {
  tagName: 'div',
  page: 1,
  total: 0,
  itemTag: 'NuxtLink',

})
const router = useRouter()
const previous = computed(() => props.page > 1)
const next = computed(() => props.page < props.total)

const isLink = computed(() => props.itemTag === 'NuxtLink')

const value = ref<string>(`${props.page}`)
function updateValue(e: Event) {
  const target = e.target as HTMLInputElement
  value.value = target.value.trim()
}
function enterHandler() {
  const newPage = Number(unref(value))
  if (newPage === props.page) {
    return
  }
  else if (newPage < 1 || newPage > props.total || Number.isNaN(newPage)) {
    useMessage.warning(`输入页码无效`, { duration: 1500 })
    return
  }

  if (isLink.value)
    router.push(props.to!(Number(unref(value))))

  else
    props.to!(Number(unref(value)))
}

function previousRender() {
  return h(isLink.value ? NuxtLink : props.itemTag, isLink.value
    ? {
        href: (props.to && previous.value) ? props.to(props.page - 1) : undefined,
        class: ['pl-3 pr-4 text-3 flex items-center rounded-md bg-white border-1 border-gray-200 h-8', previous.value ? '' : 'cursor-not-allowed text-gray-400'],
      }
    : {
        onClick: () => (props.to && previous.value) ? props.to(props.page - 1) : undefined,
        class: ['pl-3 pr-4 text-3 flex items-center rounded-md bg-white border-1 border-gray-200 h-8 cursor-pointer', previous.value ? '' : 'cursor-not-allowed text-gray-400'],

      }, [
    h('i', { class: 'i-material-symbols:keyboard-double-arrow-left-rounded' }),
    h('span', '上一页'),
  ])
}
function nextRender() {
  return h(isLink.value ? NuxtLink : props.itemTag, isLink.value
    ? {
        href: (props.to && next.value) ? props.to(props.page + 1) : undefined,
        class: ['px-4 pr-3 text-3 flex items-center rounded-md bg-white border-1 border-gray-200 h-8', next.value ? '' : 'cursor-not-allowed text-gray-400'],
      }
    : {
        onClick: () => (props.to && next.value) ? props.to(props.page + 1) : undefined,
        class: ['px-4 pr-3 text-3 flex items-center rounded-md bg-white border-1 border-gray-200 h-8 cursor-pointer', next.value ? '' : 'cursor-not-allowed text-gray-400'],
      }, [
    h('span', '下一页'),
    h('i', { class: 'i-material-symbols:keyboard-double-arrow-right-rounded' }),
  ])
}

onMounted(() => {
  const stop = watch(() => props.page, (nv) => {
    value.value = String(nv)
  })
  onUnmounted(() => {
    stop && stop?.()
  })
})
</script>

<template>
  <component :is="props.tagName" class="flex items-center justify-between h-8 text-4">
    <component :is="previousRender" />
    <div h-full py-1 text-gray-500 class="flex items-center font-mono">
      <div class="relative flex-shrink-0 h-120% min-w-10 flex items-center">
        <span class="px-2 inline-block w-full rounded-md">{{ value }}</span>
        <input
          title="回车跳转" pattern="[0-9]*"
          class="absolute w-full h-full top-0 text-center left-0 right-0 bottom-0 rounded-md px-2 border-1 border-gray-3"
          type="text" :value="value" @input="updateValue" @keydown.enter="enterHandler"
        >
      </div>
      <span class="mx-2 text-3">/</span>
      <span>{{ props.total }}</span>
    </div>
    <component :is="nextRender" />
  </component>
</template>
